import React, { useEffect } from 'react';
import { Shell, Section, Eyebrow, GoldRule, SectionHeading } from '../../components/ui/Layout';
import { ButtonLink } from '../../components/ui/Button';
import { aboutCommitments, aboutCta, aboutHero, aboutPillars, aboutStats, aboutStory, awards, corporateValues, leadershipTeam } from '../../data/aboutPage';
import { applyPageMeta } from '../../utils/seo';
const HERO_IMAGE = 'https://cdn.magicpatterns.com/patterns/generated-images/71147224-ee46-4b76-a914-e0048308439e.jpg';
const INTELLIGENCE_IMAGE = 'https://cdn.magicpatterns.com/uploads/ddYWj7PoewWgLGNhh2BmWY/pasted-image.png';
export function About() {
  useEffect(() => {
    applyPageMeta({
      title: 'About Velnoris Executive Network',
      description: aboutHero.supporting,
      canonicalPath: '/about'
    });
  }, []);
  return <main id="main" data-id="element-611" data-mp="3mf6uvk0sl7r3">
      {/* Hero */}
      <div className="on-dark relative isolate overflow-hidden bg-ink" data-id="element-612" data-mp="3qepemcgvncsc">
        <img src={HERO_IMAGE} alt="" width={1376} height={774} loading="eager" className="pointer-events-none absolute inset-0 h-full w-full object-cover opacity-30" data-id="element-613" data-mp="3qh1wyqqjrp5x" />
        <div aria-hidden="true" className="absolute inset-0 bg-ink/70" data-id="element-614" data-mp="2uby42gxa9gnc" />
        <Shell className="relative py-20 md:py-28" data-id="element-615" data-mp="2ua4uotvacibn">
          <div className="max-w-3xl animate-rise-in" data-id="element-616" data-mp="2pepkqd0ef6ki">
            <GoldRule data-id="element-617" data-mp="3n14zv85crs4w" />
            <Eyebrow onDark className="mt-5" data-id="element-618" data-mp="3n1etd5plwhfc">
              {aboutHero.eyebrow}
            </Eyebrow>
            <h1 className="mt-4 font-serif text-[2rem] leading-[1.1] tracking-[-0.015em] text-parchment md:text-[3rem]" data-id="element-619" data-mp="3i1si31tc9b96">
              {aboutHero.headline}
            </h1>
            <p className="mt-6 max-w-2xl font-serif text-[1.0625rem] leading-relaxed text-navy-100 md:text-[1.125rem]" data-id="element-620" data-mp="383w504guc68f">
              {aboutHero.supporting}
            </p>
          </div>
        </Shell>
      </div>

      {/* Story */}
      <Section labelledBy="story-heading" data-id="element-621" data-mp="1wno03wdxsitl">
        <div className="grid gap-12 lg:grid-cols-[1fr_1.25fr] lg:gap-20" data-id="element-622" data-mp="1wr24tba2p447">
          <div data-id="element-623" data-mp="oprzlnsexzs6">
            <GoldRule data-id="element-624" data-mp="on5s1o5ivk9y" />
            <Eyebrow className="mt-5" data-id="element-625" data-mp="sqvikj5rcbxm">{aboutStory.eyebrow}</Eyebrow>
            <h2 id="story-heading" className="mt-3 font-serif text-[1.75rem] leading-[1.15] text-ink md:text-[2.25rem]" data-id="element-626" data-mp="sq2ejpy6o0j6">
              {aboutStory.heading}
            </h2>
          </div>
          <div className="space-y-6" data-id="element-627" data-mp="jom6houucai4">
            <p className="font-serif text-[1.0625rem] leading-relaxed text-charcoal-700" data-id="element-628" data-mp="51awvsi7z0kn">{aboutStory.body}</p>
            <p className="border-l-2 border-gold pl-5 font-serif text-[1.0625rem] leading-relaxed text-ink" data-id="element-629" data-mp="9rrbvh1ouu94">
              {aboutStory.closing}
            </p>
          </div>
        </div>
      </Section>

      {/* Mission, vision, reach */}
      <Section tone="parchment" labelledBy="pillars-heading" data-id="element-630" data-mp="107g93scl0id">
        <h2 id="pillars-heading" className="sr-only" data-id="element-631" data-mp="3i7azo0jlbkgs">
          Our mission, vision and global reach
        </h2>
        <ul className="grid gap-10 md:grid-cols-3" data-id="element-632" data-mp="3n75si9mxek4h">
          {aboutPillars.map(pillar => <li key={pillar.label} className="flex flex-col border-t-2 border-ink pt-6" data-id="element-633" data-mp="33kcbqfjxz86t">
              <h3 className="font-sans text-eyebrow uppercase text-charcoal-300" data-id="element-634" data-mp="2zk0tf9f1xjyi">{pillar.label}</h3>
              <p className="mt-4 font-serif text-[1.125rem] leading-relaxed text-ink" data-id="element-635" data-mp="3djtfusjjpe0o">{pillar.body}</p>
            </li>)}
        </ul>
      </Section>

      {/* Stats */}
      <div className="on-dark bg-ink" data-id="element-636" data-mp="3mjyhsn5yzk7g">
        <Shell className="py-14 md:py-16" data-id="element-637" data-mp="3minhwyfnawlm">
          <dl className="grid grid-cols-2 gap-x-10 gap-y-10 lg:grid-cols-4" data-id="element-638" data-mp="3mhlvjxt6inol">
            {aboutStats.map(stat => <div key={stat.label} className="border-l border-navy-600 pl-5" data-id="element-639" data-mp="44350mrdfem">
                <dt className="sr-only" data-id="element-640" data-mp="6853d13k4c9">{stat.label}</dt>
                <dd data-id="element-641" data-mp="3rbzrc1br6wts">
                  <span className="block font-serif text-[2rem] leading-none text-gold md:text-[2.75rem]" data-id="element-642" data-mp="3rbgjjdfthoth">
                    {stat.figure}
                  </span>
                  <span className="mt-3 block font-sans text-[0.8125rem] text-navy-100" data-id="element-643" data-mp="54je5ljkiatf">{stat.label}</span>
                </dd>
              </div>)}
          </dl>
        </Shell>
      </div>

      {/* Values */}
      <Section labelledBy="values-heading" data-id="element-644" data-mp="23jpho2qrleqh">
        <SectionHeading eyebrow="Corporate Values" title="The principles behind every decision" data-id="element-645" data-mp="28cadf9t8e1wn" />
        <ul className="mt-12 grid gap-x-10 gap-y-9 md:grid-cols-2 lg:grid-cols-3" data-id="element-646" data-mp="2dau0jdjk9jql">
          {corporateValues.map(value => <li key={value.name} className="border-t border-navy-100 pt-5" data-id="element-647" data-mp="1foegc3zr27zc">
              <h3 className="font-serif text-[1.125rem] text-ink" data-id="element-648" data-mp="1klwgb4vshcv7">{value.name}</h3>
              <p className="mt-2 font-sans text-[0.875rem] leading-relaxed text-charcoal-500" data-id="element-649" data-mp="1pliv3ir9n164">{value.description}</p>
            </li>)}
        </ul>
      </Section>

      {/* Leadership */}
      <Section tone="parchment" labelledBy="leadership-heading" data-id="element-650" data-mp="310o9vl4o8q63">
        <SectionHeading eyebrow="Leadership Team" title="The advisors behind Velnoris" data-id="element-651" data-mp="310ek9ynjgl0x" />
        <ul className="mt-12 grid gap-x-10 gap-y-10 sm:grid-cols-2 lg:grid-cols-4" data-id="element-652" data-mp="35y7ncitjoywz">
          {leadershipTeam.map(leader => <li key={leader.name} data-id="element-653" data-mp="ue8fwocyu05c">
              <div aria-hidden="true" className="flex h-16 w-16 items-center justify-center border border-navy-200 bg-white font-serif text-[1.125rem] tracking-[0.06em] text-ink" data-id="element-654" data-mp="pd2mspfe8ava">
                {leader.initials}
              </div>
              <h3 className="mt-5 font-serif text-[1.125rem] text-ink" data-id="element-655" data-mp="ao6j14kddk0h">{leader.name}</h3>
              <p className="mt-1 font-sans text-[0.8125rem] leading-relaxed text-charcoal-500" data-id="element-656" data-mp="6muockmn28lf">{leader.title}</p>
            </li>)}
        </ul>
      </Section>

      {/* Recognition */}
      <Section labelledBy="awards-heading" data-id="element-657" data-mp="1pl0h9ewe4zp">
        <div className="grid gap-12 lg:grid-cols-[1fr_1.25fr] lg:gap-20" data-id="element-658" data-mp="3sv2yaek5qydn">
          <div data-id="element-659" data-mp="1w2ax3ywnhsas">
            <GoldRule data-id="element-660" data-mp="1w213808hj0zt" />
            <Eyebrow className="mt-5" data-id="element-661" data-mp="1w19aqya6pjdr">Recognition</Eyebrow>
            <h2 id="awards-heading" className="mt-3 font-serif text-[1.75rem] leading-[1.15] text-ink md:text-[2.25rem]" data-id="element-662" data-mp="1r26gm8vqsxkk">
              Awards &amp; honors
            </h2>
          </div>
          <ol className="divide-y divide-navy-100 border-y border-navy-100" data-id="element-663" data-mp="3q9d3xng6bghl">
            {awards.map(award => <li key={award.year} className="flex items-baseline gap-6 py-5" data-id="element-664" data-mp="3bli8w0ep101c">
                <span className="w-14 shrink-0 font-sans text-micro tracking-[0.16em] text-gold-700" data-id="element-665" data-mp="3gjk39hhkkls4">{award.year}</span>
                <span className="font-serif text-[1.0625rem] leading-snug text-ink" data-id="element-666" data-mp="83qlz0fez6a0">{award.title}</span>
              </li>)}
          </ol>
        </div>
      </Section>

      {/* Commitments */}
      <Section tone="parchment" labelledBy="commitments-heading" data-id="element-667" data-mp="3uc02063ftxn8">
        <h2 id="commitments-heading" className="sr-only" data-id="element-668" data-mp="34x6x3khb77q">
          Our commitments
        </h2>
        <div className="grid items-center gap-12 lg:grid-cols-[1.1fr_1fr] lg:gap-16" data-id="element-669" data-mp="2iw1mbjdr8dd1">
          <ul className="space-y-10" data-id="element-670" data-mp="2iyecgjto1u16">
            {aboutCommitments.map(item => <li key={item.heading} className="border-l-2 border-gold pl-6" data-id="element-671" data-mp="2nt1qfor1n61i">
                <h3 className="font-serif text-[1.25rem] text-ink" data-id="element-672" data-mp="15vycyu2p6udi">{item.heading}</h3>
                <p className="mt-3 font-serif text-[1.0625rem] leading-relaxed text-charcoal-700" data-id="element-673" data-mp="10xdf31ax4ms8">{item.body}</p>
              </li>)}
          </ul>
          <img src={INTELLIGENCE_IMAGE} alt="A consultant reviewing a talent intelligence dashboard of market and placement data." width={1280} height={800} loading="lazy" className="h-full w-full object-cover" data-id="element-674" data-mp="1awmbs1x64fia" />
        </div>
      </Section>

      {/* CTA */}
      <Section tone="ink" labelledBy="about-cta-heading" data-id="element-675" data-mp="w054pmw0hn1j">
        <div className="max-w-2xl" data-id="element-676" data-mp="r8vg8pm78pr8">
          <GoldRule data-id="element-677" data-mp="r7kaik9717xh" />
          <h2 id="about-cta-heading" className="mt-5 font-serif text-[1.75rem] leading-[1.15] text-parchment md:text-[2.5rem]" data-id="element-678" data-mp="r7bysvot48nv">
            {aboutCta.heading}
          </h2>
          <p className="mt-5 font-serif text-[1.0625rem] leading-relaxed text-navy-100" data-id="element-679" data-mp="3vlsc787fjv1p">{aboutCta.body}</p>
          <div className="mt-9 flex flex-col gap-3 sm:flex-row" data-id="element-680" data-mp="odjkad6ajnj2">
            <ButtonLink to="/contact" size="lg" data-id="element-681" data-mp="tat6zl2apl37">
              Book a Consultation
            </ButtonLink>
            <ButtonLink to="/services" size="lg" variant="onDark" data-id="element-682" data-mp="xcn5pnsxkf0q">
              Explore Solutions
            </ButtonLink>
          </div>
        </div>
      </Section>
    </main>;
}